module.exports = __webpack_public_path__ + "assets/img/verdict_bg_ok.svg";